// src/mainComponents/Bitrix24/index.tsx
import React, { useState, Suspense } from "react";
import { Heading, Img, Button } from "../../components";
import { useTranslation } from "react-i18next";
import Activation from "../../components/Activation";

export default function MainBitrix24() {
    const { t } = useTranslation();
    const [slide, setSlide] = useState(0);
    const slidesCount = 2;



    const ActivationStepGrip = [
        {
            stepNumber: "01",
            stepDescription: t("bitrix24.cover.2.contentNumber.1"),
            stepDescriptionSM: t("bitrix24.cover.2.contentNumber.1"),
        },
        {
            stepNumber: "02",
            stepDescription: t("bitrix24.cover.2.contentNumber.2"),
            stepDescriptionSM: t("bitrix24.cover.2.contentNumber.2"),
        },
        {
            stepNumber: "03",
            stepDescription: t("bitrix24.cover.2.contentNumber.3"),
            stepDescriptionSM: t("bitrix24.cover.2.contentNumber.3"),
        },
        {
            stepNumber: "04",
            stepDescription: t("bitrix24.cover.2.contentNumber.4"),
            stepDescriptionSM: t("bitrix24.cover.2.contentNumber.4"),
        },
    ];

    return (
        <section id="Cover">
            <div className="container-xs lg:px-6 md:px-5 sm:px-[16px]">
                {/* slider wrapper */}
                <div className="relative overflow-hidden my-8">
                    {/* slides track */}
                    <div
                        className="flex transition-transform duration-500"
                        style={{ transform: `translateX(-${slide * 100}%)` }}
                    >
                        {/* Slide 1 */}
                        <div className="flex-shrink-0 w-full flex justify-center">
                            <div className="flex justify-center rounded-[9999px] md:rounded-[64px] sm:rounded-[32px] bg-[#333333] lg:px-20 lg:py-[130px]">
                                <div className="flex md:grid sm:grid w-full items-center justify-between gap-5 md:gap-5 md:p-10 sm:gap-4 sm:p-4">
                                    <div className="flex lg:w-[48%] flex-col items-start gap-12 md:gap-9 sm:gap-4">
                                        <div className="flex flex-col gap-[20px] self-stretch sm:gap-2">
                                            <Heading
                                                size="desktop_heading_2"
                                                className="sm:hidden md:hidden font-medium leading-[110%] text-[#FFFFFF]"
                                            >
                                                {t("bitrix24.cover.1.title")}
                                            </Heading>
                                            <Heading
                                                size="desktop_body_xl"
                                                className="sm:hidden md:hidden font-medium text-[#FFFFFFB8]"
                                            >
                                                {t("bitrix24.cover.1.description")}
                                            </Heading>
                                            {/* адаптивные заголовки */}
                                            <Heading
                                                size="desktop_heading_2"
                                                className="lg:hidden sm:hidden font-medium leading-[110%] text-[#FFFFFF]"
                                            >
                                                {t("bitrix24.cover.1.title")}
                                            </Heading>
                                            <Heading
                                                size="desktop_body_l"
                                                className="lg:hidden sm:hidden font-medium text-[#FFFFFFB8]"
                                            >
                                                {t("bitrix24.cover.1.description")}
                                            </Heading>
                                            <Heading
                                                size="desktop_heading_4"
                                                className="lg:hidden md:hidden font-medium leading-[110%] text-[#FFFFFF] uppercase"
                                            >
                                                {t("bitrix24.cover.1.title")}
                                            </Heading>
                                            <Heading
                                                size="desktop_body_m"
                                                className="lg:hidden md:hidden font-medium text-[#FFFFFFB8]"
                                            >
                                                {t("bitrix24.cover.1.description")}
                                            </Heading>
                                        </div>
                                        <a
                                            href="https://www.bitrix24.ru/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                        <Button
                                            shape="round"
                                            className="h-[56px] sm:h-[44px] w-[320px] bg-[#FFB800] hover:bg-[#FFC224] sm:min-w-[320px] sm:max-w-[559px] sm:w-full"
                                        >
                                            <Heading
                                                size="desktop_body_m_bold"
                                                className="font-extrabold text-[#1B1F3B] lg:uppercase"
                                            >
                                                {t("bitrix24.cover.1.button")}
                                            </Heading>
                                            <img
                                                src={"/images/arrowRightProductsPage.svg"}
                                                alt={"arrow right"}
                                                className={`pl-2`}/>
                                        </Button>
                                        </a>
                                    </div>
                                    <Img
                                        src="/images/Bitrix24Section.png"
                                        alt="cover"
                                        className="object-contain w-[633px] md:mx-auto sm:w-auto sm:h-auto"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Slide 2 */}
                        <div className="flex-shrink-0 w-full flex justify-center">
                            <div className="container-xs flex justify-center">
                                <div className="w-full rounded-[99999px] md:rounded-[64px] sm:rounded-[32px] bg-[#333333] px-20 pr-14 md:px-6 py-[84.5px] md:py-6 sm:px-6 sm:py-6">
                                    <div className="mb-[22px] flex items-center lg:justify-between md:grid sm:grid gap-5 md:gap-12">
                                        <div>
                                            <Heading
                                                size="desktop_heading_2"
                                                className="font-medium text-[#FFFFFF] lg:w-[515px] sm:hidden"
                                            >
                                                {t("bitrix24.cover.2.title")}
                                            </Heading>
                                            <Heading
                                                size="desktop_heading_4"
                                                className="font-medium text-[#FFFFFF] lg:w-[515px] md:hidden lg:hidden"
                                            >
                                                {t("bitrix24.cover.2.title")}
                                            </Heading>
                                            <Heading
                                                size="desktop_body_xl"
                                                className="font-medium text-[#FFFFFF] lg:w-[515px] whitespace-break-spaces mt-5"
                                            >
                                                {t("bitrix24.cover.2.description")}
                                            </Heading>
                                            <a
                                                href="https://www.bitrix24.ru/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                            <Button
                                                shape="round"
                                                className="h-[56px] sm:h-[44px] w-[320px] bg-[#FFB800] hover:bg-[#FFC224] sm:w-full mt-[48px]"
                                            >
                                                <Heading
                                                    size="desktop_body_m_bold"
                                                    className="font-extrabold text-[#1B1F3B] lg:uppercase"
                                                >
                                                    {t("bitrix24.cover.2.button")}
                                                </Heading>
                                                <img
                                                    src={"/images/arrowRightProductsPage.svg"}
                                                    alt={"arrow right"}
                                                    className={`pl-2`}/>
                                            </Button>
                                            </a>
                                        </div>
                                        <div className="lg:ml-[111px] grid lg:w-[54%] grid-cols-2 gap-5 gap-y-10 sm:gap-x-2 sm:gap-y-2 ">
                                            <Suspense fallback={null}>
                                                {ActivationStepGrip.map((d, index) => (
                                                    <Activation {...d} key={index} />
                                                ))}
                                            </Suspense>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* bullets */}
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex bg-[#E6E6E64D] w-12 h-6 rounded-full px-auto mb-12 justify-center gap-2 sm:mb-6">
                        {Array.from({ length: slidesCount }).map((_, idx) => (
                            <button
                                key={idx}
                                onClick={() => setSlide(idx)}
                                className={`w-2 h-2 rounded-full transition my-auto ${
                                    slide === idx ? "bg-[#FFB800]" : "bg-[#FFFFFF80]"
                                }`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
